const ENDPOINT = new Map();

ENDPOINT.set('get', '/plugin/calendar/class/schedule');

export default ENDPOINT
